export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=40396cfbb9ac9c48611ea9686527ae80d59aff8eb1&name=getProductServerAction!'